/* eslint-disable */
import React, { Component } from 'react';
import Select from 'react-select';
import { executeHttpRequest } from '../../../epics/api';

import history from '../../../history';

export default class ClientSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            content: [],
            value: [],
        };
    }

    getClients = (input, callback) => {
        input = input.toLowerCase().split(' ').join('+');
        if (this._timeout) {
            // if there is already a timeout in process cancel it
            clearTimeout(this._timeout);
        }
        this._timeout = setTimeout(() => {
            this._timeout = null;
            executeHttpRequest(`clients/?search=${input}`).then(response => {
                callback(null, {
                    options: response.data.content,
                    complete: true,
                });
            });
        }, 300);
    };

    onChange = value => {
        const urlParams = new URLSearchParams(history.location.search);
        urlParams.set('page', 1);
        urlParams.delete('bookings_client');
        this.setState({
            value,
        });
        const query = value.map(client => client.id);
        query.forEach(clientId => {
            if (clientId) {
                console.log('ADDING', clientId);
                urlParams.append('bookings_client', clientId);
            }
        });
        history.push({
            pathname: history.location.pathname,
            search: urlParams.toString(),
        });
    };

    render() {
        const style = {
            minWidth: '175px',
            maxWidth: '225px',
            height: '53px',
        };

        const menuContainerStyle = {
            width: '100%',
            zIndex: '100',
            boxShadow: '0 2px 15px 0 rgba(0, 0, 0, 0.15)',
            border: 'none',
        };

        const wrapperStyle = {
            postition: 'relative',
        };

        return (
            <Select.Async
                multi={true}
                loadOptions={this.getClients}
                onChange={this.onChange}
                value={this.state.value}
                valueKey="id"
                labelKey="company_name"
                placeholder="Filter by Client"
                style={style}
                menuContainerStyle={menuContainerStyle}
                wrapperStyle={wrapperStyle}
                className="select-client-search"
                filterOption={() => true}  // removes the default react-select filtering on top of API response
            />
        );
    }
}
